module.exports = __webpack_public_path__ + "media/images/badge-0582e0d9e25c31e62429d96ef69101d6.svg";